<script setup>
const props = defineProps(['model', 'isSelected'])
const emit = defineEmits(['addFilter', 'removeFilter'])

function toggleFilter() {
  if (props.isSelected) {
    emit('removeFilter', props.model.optionUrlName.value)
  }
  else {
    emit('addFilter', props.model.optionUrlName.value)
  }
}
</script>

<template>
  <button
    class="bg-med-light-aqua rounded-3xl py-1 px-2 m-1 text-sm"
    :class="isSelected ? 'border-2 border-med-deep-navy font-medium' : ''"
    @click="toggleFilter"
  >
    {{ model.optionName.value }}
  </button>
</template>
